import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { Alarm } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
// Session Time Picker
export default function SessionTimePicker(props: {
  show: boolean;
  onHide: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  [x: string]: any;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={props.show} onClose={props.onHide} fullWidth maxWidth="xs">
      <DialogTitle
        style={{
          color: "#525252",
          marginBottom: -25,
        }}
      >
        {props.title}
      </DialogTitle>
      <hr />
      <form onSubmit={props.onSubmit} onReset={props.onHide}>
        <DialogContent>
          <TextField
            required
            title=""
            fullWidth
            type="number"
            variant="outlined"
            name={
              props.currentItem
                ? props.currentItem.session_length
                  ? "session_length"
                  : props.currentItem.session_length_long
                  ? "session_length_long"
                  : props.currentItem.session_interval
                  ? "session_interval"
                  : ""
                : ""
            }
            defaultValue={
              props.currentItem
                ? props.currentItem.session_length ||
                  props.currentItem.session_length_long ||
                  props.currentItem.session_interval
                : ""
            }
            inputProps={{
              min: 0,
              max: 300, // 5 hours
              step: 5,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Alarm />
                  {t("Minutes")}
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <hr />
        <DialogActions>
          <Button
            type="reset"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#333333",
              textTransform: "capitalize",
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "var(--text-primary)",
              color: "#ffffff",
              textTransform: "capitalize",
            }}
          >
            {t("Done")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
